import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { sendTrackingInfo } from '@panel/commons';
import { select } from '@panel/commons/core/themev2';
import InformativeTooltip from '@panel/commons/lib/Tooltip/InformativeTooltip';

const LeadsInfo = ({ posting, isOnline }) => {
  const { t } = useTranslation();
  const { leads, postingId, viewsStats, impressionsStats } = posting;

  const linkToLeads = `../panel/interesados?&idAviso=${postingId}&from=aviso`;

  return (
    <Container>
      <InfoItem>
        <Label data-panel='info-exposition-label'>{t('panel.avisos.posting.exposition')}</Label>
        <InformativeTooltip dataPanel='info-exposition-mobile' fixedPosition='top' backgroundColor='black'>
          <TooltipComponent>{t(`panel.avisos.posting.exposition.tooltip`)}</TooltipComponent>
        </InformativeTooltip>
        <Count>{impressionsStats || isOnline ? `${impressionsStats || 0}` : '-'}</Count>
      </InfoItem>
      <InfoItem>
        <Label data-panel='info-visits-label'>{t('panel.avisos.posting.visits')}</Label>
        <InformativeTooltip dataPanel='info-visits-mobile' fixedPosition='top' backgroundColor='black'>
          <TooltipComponent>{t(`panel.avisos.posting.visits.tooltip`)}</TooltipComponent>
        </InformativeTooltip>
        <Count>{viewsStats || isOnline ? `${viewsStats || 0}` : '-'}</Count>
      </InfoItem>
      <InfoItem>
        <Label data-panel='info-interested-label'>{t('postings.card.info.interested')}</Label>
        <InformativeTooltip dataPanel='info-interested-mobile' fixedPosition='top' backgroundColor='black'>
          <TooltipComponent>{t(`panel.avisos.posting.interested.tooltip`)}</TooltipComponent>
        </InformativeTooltip>
        <Count>{leads || isOnline ? `${leads || 0}` : '-'}</Count>
        <LeadsLink
          href={linkToLeads}
          target='_blank'
          rel='noopener noreferrer'
          onClick={() => {
            sendTrackingInfo('Panel', 'Mis avisos', 'Card del aviso-Ver consultas');
          }}
          data-panel='info-interested-CTA'
        >
          {t('panel.aviso.card.leads')}
        </LeadsLink>
      </InfoItem>
    </Container>
  );
};

export default LeadsInfo;

const Container = styled.div`
  min-height: 220px;
  width: 100%;
  border-radius: 4px;
  padding: 8px;
  border: 1px solid ${select('middleGray')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 18px 15px 18px;
  width: 100%;
  border-bottom: 1px solid ${select('middleGray')};
  :last-of-type {
    border-bottom: none;
  }
  > div {
    :nth-of-type(2) {
      position: relative;
      top: -2px;
    }
  }
`;

const Label = styled.div`
  display: inline-block;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  margin-right: 5px;
  color: ${select('darkGray')};
`;

const Count = styled.div`
  font-family: Hind;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 31px;
  letter-spacing: 0em;
  color: ${select('darkGray')};
  margin-left: 18px;
`;

const LeadsLink = styled.a`
  text-decoration: none;
  height: 31px;
  width: 104px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${select('lightGray')};
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.18);
  color: black;
  font-size: 12px;
  margin-left: auto;
`;

const TooltipComponent = styled.div`
  width: 200px;
  white-space: pre-wrap;
  height: 100%;
`;
